<template>
  <!-- Enlarged Photo -->  
  
  <div class="g2" v-if="activeIndex >= 0">    
    <button class="b1" @click="closeImages">x</button>
    <div v-click-outside="closeImages" class="g3">
      <button class="bl" @click="leftClick">&lt;</button>
      <img class="t2"  :src="images[activeIndex].src" :alt="images[activeIndex].title" />           
      <button class="br" @click="rightClick">&gt;</button>
    </div>
    
  </div>
  <!-- Thumbnails -->
  <div class="g1">    
    <img class="t1" style="object-fit:contain"  v-for="(image, index) in images" :key="index" :src="image.src" :alt="image.title" @click="activeIndex=index"/>            
  </div>
</template>

<script>

export default {  
  props: { images: Array},  
  data() {
    return {
      activeIndex: -1,
      btnClick: false,
    }
  },  
  watch: {
    activeIndex(){
      if(this.activeIndex>=0){
        document.body.style.overflow="hidden";
      } else {
        document.body.style.overflow="unset";
      }
    }
  },
  // computed: {
  //   viewHeight() {
  //     return this.$store.getters.viewHeight;
  //   }
  // },
  methods: {
    rightClick() {      
      this.btnClick = true;
      if(this.activeIndex+1 < this.images.length){
        this.activeIndex = this.activeIndex+1;
      } else {
        this.activeIndex = 0;
      }
      // Reset btnClick after a short delay
      setTimeout(() => {
        this.btnClick = false;
      }, 100);
    },
    leftClick() {
      this.btnClick = true;
      if(this.activeIndex-1 >= 0){           
        this.activeIndex = this.activeIndex - 1;
      } else {
        this.activeIndex = this.images.length-1;        
      }
      // Reset btnClick after a short delay
      setTimeout(() => {
        this.btnClick = false;
      }, 100);
    },
    closeImages(){
      if(!this.btnClick){
        this.activeIndex = -1;
      }
    },
    handleKeyPress(e){
      if(this.activeIndex >= 0){
        if(e.key==="ArrowRight"){
          this.rightClick();
        } else if(e.key==="ArrowLeft") {
          this.leftClick();
        } else if(e.key==="Escape") {
          this.activeIndex=-1;
        }
      }
    }
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeyPress);            
  }
}
</script>

<style scoped>
button {
  font-family: 'Akatab';
  font-size: 30px;
  height: 40px;
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: v-bind(colorPurple);
  border-radius: 10px;
  border: none;
  color: white;
  margin: 30px;
}
/* Thumbnails */
.t1 {
  width: 23%;
  /* aspect-ratio: 3/2;   */
  margin:2%;    
  border-radius: 10px;
  border: 4px solid v-bind(colorPurple);
  /* background-color: rgb(112, 115, 121); */
}
.t1:hover {
  cursor: pointer;
  transform: scale(1.05);
}
.g1 {
  text-align:center;  
  padding: 1%;
  z-index:1;
  /* border-style: inset; */
  /* border: 3px inset grey; */
  /* background-color: v-bind(colorBlue2); */
  /* border-radius: 10px; */
  margin-bottom: 50px;
}

.g2 {
  position: fixed;
  width: 100vw;
  height: 100vh;
  /* height: 100vh; */
  /* height: v-bind('viewHeight'); */
  top:0;
  left:0;
  /* background-color: rgba(56, 56, 56, 0.796); */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index:100;
  overflow:hidden;
      background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(5px);
}
.g3 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 100;
}
.b1:hover, .bl:hover, .br:hover {
  background-color: grey;
  cursor: pointer;
}

.t2 {
  max-width:80vw;
  /* max-height:calc(v-bind('viewHeight') * .8); */
  max-height: 80vh;
  border-radius: 10px;
  border: 4px solid v-bind(colorPurple);
}
@media only screen and (max-width: 900px) {
  button {
    margin: 10px;
  }
  .t2 {
    max-width: 60%;
  }
  .g3 {
    justify-content: center;
  }
}
</style>